
import OcSlider from '@marketplace/components/shared/container/oc-slider.vue'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalImages',

    components: {
        OcSlider,
    },

    props: {
        images: {
            type: Array,
            default: () => [],
            // expects a default style GQL edges response -> image.node.transformedUrl
            // might need a refactor one day
        },
        link: {
            type: Object,
            default: null,
        },
        defaultImageIndex: {
            type: Number,
            default: 0,
        },
        refreshSliderTimestamp: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            currentImageIndex: this.defaultImageIndex,
        }
    },

    computed: {
        imageAlt() {
            return this.$metaInfo?.title || ''
        },
    },

    methods: {
        closeModal() {
            EventBus.$emit('modal-close')
        },
        moveLeft() {
            this.__moveSlide('+', 'currentImageIndex', this.images.length)
        },
        moveRight() {
            this.__moveSlide('-', 'currentImageIndex', this.images.length)
        },
        __moveSlide(direction, identifier, slideslength) {
            if (direction === '+' && this[identifier] < slideslength - 1) {
                this[identifier]++
            }
            if (direction === '-' && this[identifier] > 0) {
                this[identifier]--
            }
        },
    },
}
